import {createSlice} from '@reduxjs/toolkit';
import {v4 as uuidv4} from 'uuid';

const USER_TOKEN_STORAGE_KEY = 'userToken';

export function getOrCreateUserToken(): string {
  const existingUserToken = localStorage.getItem(USER_TOKEN_STORAGE_KEY);
  if (existingUserToken !== null) {
    return existingUserToken;
  }

  const userToken = uuidv4();
  localStorage.setItem(USER_TOKEN_STORAGE_KEY, userToken);
  return userToken;
}

export interface UserState {
  userToken: string;
}

export interface UserRootState {
  user: UserState;
}

const initialState: UserState = {
  userToken: getOrCreateUserToken(),
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
});

export const selectUserToken = (state: UserRootState): string => state.user.userToken;

export default userSlice.reducer;
